import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@styles/index.css';
import router from './router/index.jsx';
import { RouterProvider } from 'react-router-dom';
import { AppProvider } from './context/AppProvider.jsx';
import './i18n';
import { Toaster } from './components/shadcn-ui/sonner.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
      <Toaster position="top-center" />
    </AppProvider>
  </StrictMode>
);
